import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import AdminLayout from './Admin/components/Layout';
import Login from './Admin/pages/Login';
import AppLayout from './App/components/Layout';
import './index.scss';
import { routeMapper } from './utils/routeMapper';

const router = createBrowserRouter([
    {
        path: '/admin/login',
        element: <Login />,
        loader: () => <div>Loading login...</div>,
    },
    {
        path: '/',
        element: <AppLayout />,
        loader: () => <div>Loading basic...</div>,
        children: routeMapper.map((item) => {
            return {
                path: item.pathname,
                element: item.appComponent,
            };
        }),
    },
    {
        path: '/admin',
        element: <AdminLayout />,
        loader: () => <div>Loading admin...</div>,
        children: routeMapper.flatMap((item) => {
            if (!item.adminComponent) {
                return [];
            }
            return [
                {
                    path: `/admin${item.pathname}`,
                    element: item.adminComponent,
                },
            ];
        }),
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <RouterProvider router={router} />
    </React.StrictMode>,
);
